import React, { useEffect, useState, useRef } from "react";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { BASE_URL,BASE_IMAGE_URL } from "../../service/apiConfig";
import isEqual from "lodash/isEqual";
import get from 'lodash/get';

import {
  Select,
  Typography,
  Space,
  Button,
  Table,
  Modal,
  Form,
  Input,
  notification,
  Upload,
  message,
  Card,
  Row,
  Col,
  DatePicker,
  Radio,
  Checkbox,
  TimePicker,
  List,
  Empty
} from "antd";
import moment from "moment";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import countriesApi from "../../service/countriesApi";
import locationServiceApi from "../../service/locationserviceService";
import serviceCategoryApi from "../../service/serviceCategoriesApi";
import providerApi from "../../service/providerService";
import translateApi from "../../service/translateService";
import { useSelector } from "react-redux";
import "./management.css";
import MapManagement from "./MapManagement";
import adminService from "../../service/adminService";
import { CLOSED, FORMAT_TIME, OPEN, OPEN_24_HOURS, OPEN_24_HOURS_TEXT, TIME_24_HOUR, TIME_CLOSED, TIME_UPDATE, regularHours } from "../../constants/openHours";
import HoursModal from "../../components/HoursModal";
import SelectWeekDay from "../../components/SelectWeekDay";

const { Option } = Select;
export default function ManagementPage() {
  const deepEqual = isEqual;
  const currentLocation = useSelector((state) => state.currentLocation);
  const [serviceId, setServiceId] = useState(0);

  const [isShowUpdateService, setIsShowUpdateService] = useState(false);  
  const [listLocationService, setListLocationService] = useState([]);
  const [locationServiceData, setLocationServiceData] = useState([]);
  const [province, setProvince] = useState([]);

  const [listCountry, setListCountry] = useState([]);
  const [listServiceCategory, setListServiceCategory] = useState([]);

  const [fileListService, setFileListService] = useState([]);
  const [fileListServiceSubmit, setFileListServiceSubmit] = useState([]);

  const [loading, setLoading] = useState(false);
  const [invalidImage, setInvalidImage] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [formService] = Form.useForm();
  const [loadingTranslate, setLoadingTranslate] = useState(false);
  const [language, setLanguage] = useState("vi");
  const [titleData, setTitleData] = useState("");
  const [desData, setDesData] = useState("");
  const [dataChange, setDataChange] = useState(true);
  const [dataTranslate, setDataTranslate] = useState();
  const [lastData, setLastData] = useState({});
  const [providerList, setProviderList] = useState([]);

  const [onRegisterAds, setOnRegisterAds] = useState(false);
  const [isShowAds,  setIsShowAds] = useState(false);
  const [isCustomer,  setIsCustomerAds] = useState(false);
  const [sendNotification, setSendNotification] = useState(false);

  const [centerMap, setCenterMap] = useState({
    lat: "",
    lng: "",
  });

  const [filterOnChange, setFilterOnChange] = useState(false);
  const [hours, setHours] = useState([]);
  const [hoursSelected, setHoursSelected] = useState([]);
  const [open24h, setOpen24h] = useState(false);
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    getAllService();
    getAllProvider()
  }, [filterOnChange]);

  useEffect(() => {
    getAllProvider()
  }, []);

  const onFormValueChange = () => {
    setDataChange(true);
    console.log(formService.getFieldsValue());
  };

  const getAllService = () => {    
    if(filterOnChange) {
      locationServiceApi.getAll({'ads': true}).then((res) => {
        setListLocationService(res.data);
      });        
    }else{
      locationServiceApi.getAll().then((res) => {
        setListLocationService(res.data);
      });        
    }
     
  };

  const deleteService = () => {
    locationServiceApi.deleteLocationServiceById(serviceId).then((res) => {
      notification.success({ message: `Delete Location Service success` });
      getAllService();
      setOpenDeleteDialog(false);
    });
  };

  const onLocationChange = (location) => {
    setDataChange(true);
    formService.setFieldsValue({
      latitude: location.lat,
      longitude: location.lng,
    });
  };

  const getAllProvider = () => {
    providerApi.getAll().then((res)=>{
      setProviderList(res.data)
    })
  }

  const openModalService = (id) => {
    getCountry();
    setIsShowUpdateService(true);
    setServiceId(id);
    getServiceCategories();
    // providerApi.getAll().then((res)=>{
    //   setProviderList(res.data)
    // })
    if (id) {
      locationServiceApi.getById(id,language).then((res) => {
        const pictureFilenameParse =
          res.data.pictureFilename != null && res.data.pictureFilename != ""
            ? JSON.parse(res.data.pictureFilename)
            : [];
        const files = [];
        const filesSubmit = [];
        if (pictureFilenameParse.length > 0) {
          pictureFilenameParse.forEach((item) => {
            files.push({ url: BASE_IMAGE_URL + item });
            filesSubmit.push(item);
          });
        }
        const datHour = res.data?.hours != null && res.data?.hours != '' ? JSON.parse(res.data?.hours) : [] 
        setHours(datHour)
        setHoursChange(datHour.length > 0 ? datHour : regularHours)
        setFileListService(files);
        setFileListServiceSubmit(filesSubmit);
        setLocationServiceData(res.data);
        setTitleData(res.data.title);
        setDesData(res.data.description);
        setOnRegisterAds(res.data.isShowAds  ?? false)
        setIsShowAds(res.data.isShowAds  ?? false)
        setIsCustomerAds(res.data.isCustomer ?? false)
        setCenterMap({
          lng: res.data.longitude,
          lat: res.data.latitude,
        });
        formService.setFieldsValue({
          title: res.data.title,
          countryId: res.data.countryId,
          phone: res.data.phone,
          serviceCategoryId: res.data.serviceCategoryId,
          provinceId: res.data.provinceId,
          province: res.data.province,
          address: res.data.address,
          dateTimeClose: res.data.dateTimeClose!=null ? moment(res.data.dateTimeClose):null,
          dateTimeOpen: res.data.dateTimeOpen!=null ? moment(res.data.dateTimeOpen):null,          
          longitude: res.data.longitude,
          latitude: res.data.latitude,
          description: res.data.description,
          providerId: res.data.providerId,
          isAdsTripZe: res.data.isCustomer == true ?  false : res.data.isShowAds,
          isShowAds: res.data.isShowAds,
          isCustomer: res.data.isCustomer,
        });
      });
    }else{
      setHoursChange(regularHours)
    }
  };

  const onCloseModalService = () => {
    setIsShowUpdateService(false);
    setFileListService([]);
    setFileListServiceSubmit([]);
    setLanguage("vi");
    setServiceId(0);
    setCenterMap('');
    setIsCustomerAds(false)
    setIsShowAds(false)
    setOnRegisterAds(false)
    setHours([])
    setHoursChange([])
    formService.setFieldsValue({
      title: "",
      countryId: 0,
      provinceId: 0,
      phone: "",
      serviceCategory: "",
      province: "",
      address: "",
      longitude: "",
      latitude: "",
      description: "",
      providerId:null,
      isAdsTripZe: false,
      isShowAds: false,
      isCustomer: false,
      sendNotification: false,
    });
  };

  const onRegisterAdsChange = () => {
    setOnRegisterAds(!onRegisterAds)
    formService.setFieldsValue({isCustomer: false, isAdsTripZe: true})
    setIsShowAds(false)
    setIsCustomerAds(false)
  };

  const onSendNotificationChange = (value) => {
    setSendNotification(!sendNotification)
    formService.setFieldsValue({sendNotification: !sendNotification})
  };

  const onChangeShowAds = () => {
    formService.setFieldsValue({isCustomer: false})
    setIsShowAds(true)
    setIsCustomerAds(false)
    setDataChange(true)
  }

  const onChangeShowCustomerAds = () => {
    formService.setFieldsValue({isAdsTripZe: false})
    setIsCustomerAds(true)
    setIsShowAds(false)
    setDataChange(true)
  }

  const getCountry = () => {
    countriesApi.getAll().then((response) => {
      setListCountry(response.data);
      formService.setFieldsValue({ countryId: response.data[0].id });
      onSelectCountry(response.data[0]?.id)
    });
  };
  const getServiceCategories = () => {
    serviceCategoryApi.getAll().then((response) => {
      setListServiceCategory(response.data);
    });
  };

  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 20 },
  };

  const openDeleteService = (id) => {
    setServiceId(id);
    setOpenDeleteDialog(true);
  };
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex, placeHolderSearch) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          ref={searchInput}
          placeholder={`Tìm kiếm ${placeHolderSearch}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Tìm kiếm
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Đặt lại
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Lọc
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
    get(record, dataIndex)
    .toString()
    .toLowerCase()
    .includes(value.toLowerCase()),
      // record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      // searchedColumn === dataIndex ? (
        isEqual(searchedColumn, dataIndex) ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text?.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columnsService = [
    {
      title: "Tên dịch vụ",
      dataIndex: "title",
      key: "title",
      ...getColumnSearchProps("title", "dịch vụ"),
    },
    {
      title: "Địa chỉ",
      dataIndex: "address",
      key: "address",
      ...getColumnSearchProps("address", "địa chỉ"),
    },
    {
      title: "Số điện thoại",
      dataIndex: "phone",
      key: "phone",
      ...getColumnSearchProps("phone", "số điện thoại"),
    },
    {
      title: "Tỉnh Thành",
      dataIndex: "provinceName",
      key: "provinceName",
      ...getColumnSearchProps("provinceName", "Tỉnh Thành"),
    },
    // {
    //   title: "Thành Phố",
    //   dataIndex: "countryName",
    //   key: "countryName",
    //   ...getColumnSearchProps("countryName"),
    // },
    // {
    //   title: "Mô Tả",
    //   dataIndex: "description",
    //   key: "description",
    //   ...getColumnSearchProps("description"),
    // },
    {
      title: "Loại hình dịch vụ",
      dataIndex: "serviceName",
      key: "serviceName",
      ...getColumnSearchProps("serviceName", "loại hình dịch vụ"),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openModalService(_.id)}
          >
            Sửa
          </Button>
          <Button
            type="danger"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openDeleteService(_.id)}
          >
            Xóa
          </Button>
        </Space>
      ),
    },
  ];

  const onFinishHandleService = (values) => {
    values.pictureFilename = fileListServiceSubmit;
    console.log(values);
    values.isShowAds = values.isAdsTripZe == true ? true : values.isShowAds
    values.isCustomer = isCustomer
    values.userId = adminService.AuthService.getCurrentUser().id
    values.hours = hours
    
    if (serviceId !== 0) {
      if (language === "vi") {
        locationServiceApi
          .updatelocationService(serviceId, values)
          .then((res) => {
            notification.success({
              message: "Update location service success",
            });
            let newData = { ...lastData };
            newData[language] = formService.getFieldsValue();
            setLastData(newData);
            setDataChange(false);
            getAllService();
          });
      } else {
        var temp = {};
        temp[language] = {
          title: values.title,
          description: values.description,
        };
        // const temp={
        //   'en':{
        //     title: values.title,
        //     description: values.description,
        //   }
        // }
        const data = { 
          textTranslate: JSON.stringify(temp),
          userId: adminService.AuthService.getCurrentUser().id
        };
        locationServiceApi
          .updatelocationService(serviceId, data)
          .then((res) => {
            notification.success({
              message: "Update location service success",
            });
            setDataChange(false);
            let newData = { ...lastData };
            newData[language] = formService.getFieldsValue();
            setLastData(newData);
            getAllService();
          });
      }
    } else {
      locationServiceApi.createlocationService(values).then((res) => {
        notification.success({ message: "Create location Service success" });
        onCloseModalService();
        formService.setFieldsValue({
          title: "",
          countryId: 0,
          phone: "",
          serviceCategory: "",
          province: "",
          address: "",
          longitude: "",
          latitude: "",
          description: "",
        });
        getAllService();
      });
    }
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Thêm Ảnh
      </div>
    </div>
  );

  const handleChangeService = async ({ fileList: newFileList }) => {
    if (!invalidImage) {
      onFormValueChange()
      setFileListService(newFileList);
      const urlArray = [];
      const urlArraySubmit = [];
      let checkTotal = 0;
      let check = 0;
      await newFileList.forEach((item) => {
        if (typeof item?.status !== "undefined") {
          checkTotal++;
          if (item.status === "uploading") {
            setLoading(true);
            return;
          }
          if (item.status === "done") {
            check++;
          }
        } else {
          urlArray.push(item);
          urlArraySubmit.push("/images/" + item.url.split("/images/")[1]);
        }
      });
      if (check === checkTotal) {
        newFileList.forEach((item) => {
          if (typeof item?.status !== "undefined") {
            const temp = { url: BASE_IMAGE_URL + item.response.data.url };
            urlArray.push(temp);
            urlArraySubmit.push(item.response.data.url);
          }
        });
      }

      setFileListServiceSubmit(urlArraySubmit);
      setLoading(false);
    }
  };

  // formService.setFieldsValue({
  //   latitude:
  //     currentLocation?.latitude != ""
  //       ? currentLocation?.latitude
  //       : locationServiceData?.latitude,
  //   longitude:
  //     currentLocation?.longitude != ""
  //       ? currentLocation?.longitude
  //       : locationServiceData?.longitude,
  // });

  // const onSelectLanguage = () => {};

  const onSelectCountry = async (value) => {
    await countriesApi.getById(value).then((res) => {
      setProvince(res.data.province);
      formService.setFieldsValue({
        province: "",
      });
    });
  };

  const onSelectProvince = async (value, key) => {
    console.log(value);
    province.forEach((element) => {
      if ((element.id == key.key)) {
        setCenterMap({
          lat: element.latitude,
          lng: element.longitude,
          // longitude: element.longitude,
          // latitude: element.latitude,
        });
        
      }
    });
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";

    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      setInvalidImage(true);
    } else {
      setInvalidImage(false);
    }

    const isLt2M = file.size / 1024 / 1024 < 2;
    return isJpgOrPng;
  };

  const onChangeTitle = (value) => {
    setTitleData(value.target.value);
  };
  const onChangeDes = (value) => {
    setDesData(value.target.value);
  };

  const onSelectLanguage = async (value) => {
    setDataChange(true);
    onHandleTranslate(serviceId, value);
    setLanguage(value);
  };
  ////
  const onHandleTranslate = (id, forceLang) => {
    setLoadingTranslate(true);
    const textData = {
      title: titleData,
      description: desData,
    };
    const data = {
      text: textData,
      language: forceLang ? forceLang : language,
      type: "service",
      id: id,
    };
    translateApi.translate(data).then((res) => {
      const textTranslate = res.data;
      console.log("textTranslate", textTranslate);
      if (textTranslate.length > 0) {
        console.log("ýes");
        setLoadingTranslate(false);
        const newdata = [];
        textTranslate.map((e) => {
          if (e.language == language) {
            formService.setFieldsValue({
              title: e.title,
              description: e.description,
            });
          }
        });
        console.log("newdata", newdata);
      } else {
        let newFormData = {
          address: res.data.address,
          countryId: res.data.countryId,
          description: res.data.description,
          latitude: res.data.latitude,
          longitude: res.data.longitude,
          phone: res.data.phone,
          province: res.data.province,
          serviceCategoryId: res.data.serviceCategoryId,
          title: res.data.title,
        };
        setDataChange(false);
        if (!deepEqual(newFormData, lastData[data.language])) {
          setDataChange(true);
        }
        setDataTranslate(dataTranslate);
        formService.setFieldsValue({
          title: res.data.title,
          description: res.data.description,
        });
        setLoadingTranslate(false);
      }
    });
  };

  const onChangeFilter = (e) => {    
    setFilterOnChange(!filterOnChange);    
  }

  const [isShowOpenHours, setIsShowOpenHours] = useState(false);
  const [hoursChange, setHoursChange] = useState([]);
  const [timeOpenClose, setTimeOpenClose] = useState(TIME_CLOSED);
  const openHours = () => {
    setHoursSelected([])
    if(language ==='vi'){
      setHoursChange(hours.length > 0 ? hours : regularHours)
      setIsShowOpenHours(true)
    }
  };

  const closeModalHours = () => {
    setIsShowOpenHours(false);
    setHoursSelected([])
    setHoursChange([])
  };

  const closeSaveModalHours = () => {      
    if(hoursSelected?.length > 0) {
      console.log(`closeSaveModalHours: ${JSON.stringify(hoursChange)} `)   
      setHours(hoursChange)    
    }
    closeModalHours()
  };

  const displayItemHour = (item) => {
    const time = !item?.isOpen ? CLOSED : item.open24Hrs ?   OPEN_24_HOURS_TEXT : item.times[0].open + '-' + item.times[0].close
    return `${item.label}: ${time}`
  }

  const onUpdateHours = () => {
    if( hoursSelected?.length > 0){    
      const newArray = hoursChange.map((x, i) => {
        const selected = hoursSelected.filter(obj => obj.name === x.name)                
        const item = selected?.length > 0 ? selected[0] : null
        if (item != null && item?.removed === undefined ){          
          const obj = {
            ...x,
            ...timeOpenClose
          }
          return obj;
        } else {
          const itemPre = hours.filter(obj => obj.name === x.name)    
          const objRestore = itemPre?.length > 0 ? itemPre[0] : x
          return objRestore;
        }
      });    
      setHoursChange(newArray)
      console.log(`onUpdateHouItem: ${JSON.stringify(newArray)} `)    
    }
  }

  useEffect(() => {
    console.log(`onUpdateHours useEffect open24h: ${open24h}  isOpen=${isOpen} timeOpenClose=${JSON.stringify(timeOpenClose)} hoursSelected = ${JSON.stringify(hoursSelected)}`)    
    onUpdateHours()
  }, [timeOpenClose.times, hoursSelected])  

  useEffect(() => {    
    if(open24h === true){
      setTimeOpenClose(TIME_24_HOUR)
    }else if(isOpen === true){
      setTimeOpenClose(TIME_CLOSED)
    }else{
      const timeUpdate =  TIME_UPDATE(timeOpenClose.times?.[0].close, timeOpenClose.times?.[0].open)
      setTimeOpenClose(timeUpdate)
    }        
  }, [isOpen, open24h])  


  const modalHours = () => (
   isShowOpenHours ? <Modal
        visible={isShowOpenHours}
        onOk={closeSaveModalHours}
        onCancel={closeModalHours}
        okText={'Lưu'}
        cancelText={'Huỷ'}
        
        title={`Chọn ngày và giờ`}
      >
        <>
        <Row >
          
          <SelectWeekDay days={hours} onChange={(days) => {            
            console.log(` SelectWeekDay days : ${JSON.stringify(days)}`)            
            setHoursSelected(days)       
          }}/>
        
        </Row>
         <Row style={{paddingTop: 10, paddingBottom: 10}}>              
              <Col md={20} xs={24} >
                <Checkbox  disabled={ language!='vi' } checked={open24h}  onChange={(e) => {
                  setOpen24h(e.target.checked)
                  if(e.target.checked){
                    setIsOpen(false)
                  }
                }}>Mở cả ngày</Checkbox>
                <Checkbox  disabled={ language!='vi' } checked={isOpen}  onChange={(e) => {
                  
                    setIsOpen(e.target.checked)
                    if(e.target.checked) {
                      setOpen24h(false)         
                    }                                     
                }}>Đóng cửa</Checkbox>                           
               </Col>
               {!isOpen && !open24h ?  <Col md={40} xs={40}>
                  <Col xs={80} style={{paddingTop: 10}}>
                      {OPEN} : <TimePicker  onChange={(value) => {                        
                          const timeClose = timeOpenClose.times?.[0].close
                          const timeUpdate = TIME_UPDATE(value.format(FORMAT_TIME), timeClose)
                          setTimeOpenClose(timeUpdate)
                        }}
                      format={FORMAT_TIME}/>
                      {CLOSED}: <TimePicker onChange={(value) =>{                        
                          const timeOpen = timeOpenClose.times?.[0].open
                          const timeUpdate = TIME_UPDATE(timeOpen, value.format(FORMAT_TIME))
                          setTimeOpenClose(timeUpdate)
                        }}  format={FORMAT_TIME} />
                  </Col>                                                
                </Col> : null}
                                               
            </Row>        
        </>
      </Modal> : null
  )

  return (
    <>
      <Card
        title={
          <Typography style={{ textAlign: "center" }}>
            Quản lý Dịch Vụ
          </Typography>
        }
        extra={
          <Space>
            <Checkbox  value={1} onChange={onChangeFilter} >Dữ liệu quảng cáo</Checkbox>             
          <Button
            type="primary"
            style={{
              borderRadius: "8px",
            }}
            onClick={() => {
              setIsShowUpdateService(true);
              getServiceCategories();
              getCountry();
            }}
          >
            Tạo Dịch Vụ
          </Button>
          </Space>
        }
      >
        <Table
          columns={columnsService}
          dataSource={listLocationService}
          bordered
        />

        <Modal
          title={serviceId !== 0 ? "Cập Nhập Dịch Vụ" : "Tạo Dịch Vụ"}
          visible={isShowUpdateService}
          // onOk={handleOkTour}
          width="70%"
          onCancel={() => {
            onCloseModalService();
            setLanguage("vi");
            setServiceId(0);
          }}
          footer={[
            <>
              <Button
                size="small"
                onClick={() => {
                  setServiceId(0);
                  onCloseModalService();
                  setFileListServiceSubmit([]);
                }}
              >
                Đóng
              </Button>
              <Button
                size="small"
                className="btn btn-primary"
                type="primary"
                form="CU-tour"
                key="submit"
                htmlType="submit"
                disabled={!dataChange}
              >
                Hoàn Thành
              </Button>
            </>,
          ]}
        >
          <Row justify="space-around">
            <Col span={12}>
              {serviceId !== 0 && (
                <Row justify="end">
                  <Select
                    onChange={onSelectLanguage}
                    defaultValue="vi"
                    value={language}
                  >
                    <Option value="vi">Tiếng Việt</Option>
                    <Option value="en">English</Option>
                    <Option value="fr">French</Option>
                    <Option value="zh-CN">Chinese</Option>
                    <Option value="ko">Korean</Option>
                    <Option value="de">German</Option>
                  </Select>
                  <Button
                    type="primary"
                    onClick={() => {
                      onHandleTranslate(serviceId);
                    }}
                    loading={loadingTranslate}
                  >
                    Dịch
                  </Button>
                </Row>
              )}
              <Upload
                name="file"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={true}
                multiple={true}
                action={BASE_IMAGE_URL + "/api/upload"}
                beforeUpload={beforeUpload}
                onChange={handleChangeService}
                fileList={fileListService}
                disabled={language != "vi"}
              >
                {uploadButton}
              </Upload>
              {/* //// */}
              <Form
                {...layout}
                form={formService}
                name="CU-tour"
                onValuesChange={onFormValueChange}
                onFinish={onFinishHandleService}
              >
                <Form.Item
                  name="title"
                  label="Tên"
                  rules={[{ required: true }]}
                >
                  <Input size="large" onChange={onChangeTitle} />
                </Form.Item>
                <Form.Item
                  name="phone"
                  label="Số Điện Thoại"
                  // rules={[{ required: true }]}
                >
                  <Input size="large" disabled={language != "vi"} />
                </Form.Item>
                <Form.Item name="countryId" label="Quốc Gia">
                  <Select
                    onChange={onSelectCountry}
                    disabled={language != "vi"}
                  >
                    {listCountry?.map((x) => (
                      <Option value={x.id} key={x.id}>
                        {x.countryName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="provinceId" label="Tỉnh Thành">
                  <Select
                    onChange={onSelectProvince}
                    disabled={language != "vi"}
                  >
                    {province?.map((x) => (
                      <Option value={x.id} key={x.id}>
                        {x.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="serviceCategoryId"
                  label="Loại Hình"
                  rules={[{ required: true }]}
                >
                  <Select disabled={language != "vi"}>
                    {listServiceCategory?.map((x) => (
                      <Option value={x.id} key={x.id}>
                        {x.title}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="address" label="Địa Chỉ">
                  <Input size="large" disabled={language != "vi"} />
                </Form.Item>

                {/* <Form.Item name="dateTimeOpen" label="Giờ mở cửa">
                  <DatePicker
                    placeholder="Chọn ngày"
                    format="HH:mm" disabled={ language!='vi' }
                    showTime={{ defaultValue: moment("00:00", "HH:mm") }}
                  />
                </Form.Item> */}
                <Form.Item name="hours" label="Ngày và giờ" onClick={() => {
                  openHours()
                }}>                
                <List dataSource={hours} bordered  
                  locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={''}/> }}
                  
                style={{padding: 10,cursor:"pointer" }}          
                  renderItem={(item) => (
                    <List.Item style={{border: 0, padding:0}}>
                      <Typography.Text >{displayItemHour(item)}</Typography.Text> 
                    </List.Item>
                  )}
                >
                </List>                                
                  
                </Form.Item>                
                {/* <Form.Item name="dateTimeClose" label="Giờ đóng cửa">                  
                  <DatePicker
                    placeholder="Chọn ngày"
                    format="HH:mm" disabled={ language!='vi' }
                    showTime={{ defaultValue: moment("00:00", "HH:mm") }}
                  />
                </Form.Item> */}

                <Form.Item name="providerId" label="Nhà cung cấp">
                  {/* <Input size="large" disabled={language != "vi"} /> */}
                  <Select disabled={language != "vi"}>
                    {providerList?.map((x) => (
                      <Option value={x.id} key={x.id}>
                        {x.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="latitude"
                  label="Latitude"
                  rules={[{ required: true }]}
                >
                  <Input size="large" disabled={language != "vi"} />
                </Form.Item>
                <Form.Item
                  name="longitude"
                  label="Longitude"
                  rules={[{ required: true }]}
                >
                  <Input size="large" disabled={language != "vi"} />
                </Form.Item>

                <Form.Item
                  name="description"
                  label="
                Mô Tả"
                >
                  <Input.TextArea rows={10}  onChange={onChangeDes}></Input.TextArea>
                </Form.Item>
                <Form.Item label="Quảng cáo" name="isShowAds" valuePropName="checked">
                    <Checkbox  disabled={ language!='vi' } onChange={onRegisterAdsChange}/>                                                  
                 </Form.Item>

                {onRegisterAds ?<Form.Item label="TripZe" name="isAdsTripZe" valuePropName="checked">
                    <Radio value={'isAdsTripZe'} disabled={ language!='vi' } onChange={onChangeShowAds}/>                                                  
                 </Form.Item> : null}

                 {onRegisterAds ? <Form.Item label="Đối tác" name="isCustomer" valuePropName="checked">
                    <Radio value={'isCustomer'} disabled={ language!='vi' } onChange={onChangeShowCustomerAds}/>                                                  
                 </Form.Item> : null }            
                 <Form.Item label="Gửi thông báo" name="sendNotification" valuePropName="checked">
                    <Checkbox  disabled={ language!='vi' } onChange={onSendNotificationChange}/>                                                  
                 </Form.Item>                     
              </Form>
            </Col>
            <Col span={10}>
              <MapManagement onChange={onLocationChange} location={centerMap}/>
            </Col>
          </Row>
        </Modal>
      </Card>
      {modalHours()}
      
      <Modal
        visible={openDeleteDialog}
        onOk={deleteService}
        onCancel={() => {
          setServiceId(0);
          setOpenDeleteDialog(false);
        }}
        title={`Xóa dịch vụ`}
      >
        Bạn có muốn xóa dịch vụ này?
      </Modal>
    </>
  );
}
